module.exports = __webpack_public_path__ + "static/img/felidae.7fd6671f.png";